import axios from 'axios';
import Cookies from 'js-cookie';
import * as Sentry from '@sentry/browser';
import { message } from 'm-ui';

const POST_HINT_NAME = 'kuaishou.ad.dsp_ph';

axios.interceptors.request.use((config) => {
    config.headers.Accept = 'application/json';
    config.withCredentials = true;
    const postHint = Cookies.get(POST_HINT_NAME);
    if (config.method === 'post') {
        config.url += (config.url.indexOf('?') > -1 ? '&' : '?') + `${POST_HINT_NAME}=${postHint}`;
    }
    return config;
});

axios.interceptors.response.use(
    (res) => {
        const { data } = res;
        if (
            (data && (+data.result === 1 || +data.result === 200)) ||
            (data && +data.code === 200) ||
            (data && +data.status === 200)
        ) {
            return data;
        }
        if (data && +data.result === 109) {
            data.error_msg = '网络连接失败，请刷新当前页面。';
        }
        if (data.result !== 109) {
            Sentry.withScope((scope) => {
                scope.setExtra('url', res.config.url);
                scope.setExtra('result', data.result);
                if (data.error_msg) {
                    scope.setExtra('msg', data.error_msg);
                }
                Sentry.captureException(new Error('request error with result ' + data.result));
            });
        }
        if (data && +data.result === -1 && data.error_msg) {
            message.error(data.error_msg);
        }
        if (Object.is('arraybuffer', res.config.responseType)) {
            const filename = res.headers['content-disposition'] || '';
            return { filename, file: data };
        }
        return Promise.reject(data);
    },
    (err) => Promise.reject(err),
);

const isDev = process.env.NODE_ENV === 'development';

export function mockTimeout(timeout = 2000) {
    if (isDev) {
        return new Promise((resolve) => {
            setTimeout(resolve, timeout);
        });
    } else {
        return Promise.resolve();
    }
}

export const ping = async (url) => {
    try {
        await fetch(url, {
            method: 'HEAD',
            mode: 'no-cors',
        });
        return true;
    } catch (e) {
        return false;
    }
};

export interface Response<T> {
    result: number;
    data: T;
    message: string;
    count?: number;
}
